import React, { ChangeEvent } from 'react';
import { Checkbox, FormControlLabel, FormHelperText, SxProps, Tooltip, useTheme } from '@mui/material';
import { Control, Controller } from 'react-hook-form';
import { tokens } from '../../theme';

interface CheckboxProps {
    color?: "primary" | "secondary" | "success" | "error" | "info" | "warning";
    id?: string;
    name?: string;
    label?: any;
    control: Control<any, any>
    onChange?: (event: ChangeEvent<HTMLInputElement>) => void;
    checked?: boolean;
    isDisabled?: boolean;
    controllerName?: string;
    rules?: object;
    tooltipMessage?:string;
    tooltipPlacement?:
    | "right"
    | "left"
    | "top"
    | "bottom"
    | "bottom-end"
    | "bottom-start"
    | "left-end"
    | "left-start"
    | "right-end"
    | "right-start"
    | "top-end"
    | "top-start"
    | undefined;
    strikeThrough?: boolean;
    sx?: SxProps;

}

const CustomCheckbox: React.FC<CheckboxProps> = (props) => {

    const { color, id, name, label, control, onChange, checked, isDisabled, controllerName, rules, tooltipMessage, tooltipPlacement, strikeThrough, sx } = props;
    const theme = useTheme();
     const colors = tokens(theme.palette.mode);
    
    
    const a = (checked: any , field: any) => {
        return checked || !!field.value
    }

    return (
        <Controller
            name={controllerName || ""}
            control={control}
            rules={rules? rules: {}}
            render={({ field, fieldState }) => (
                <>
                    <Tooltip
                        title={tooltipMessage}
                        placement={tooltipPlacement || "bottom"}
                        arrow
                    >
                        <FormControlLabel
                            control={
                                <Checkbox
                                    id={id}
                                    {...field}
                                    name={name ? name : controllerName}
                                    color={color || theme.palette.mode === "dark" ? "secondary" : "primary"}
                                    size="medium"
                                    onChange={(e) => {
                                        field.onChange(e);
                                        onChange && onChange(e);
                                    }}
                                    checked={checked || !!field.value}
                                    disabled={isDisabled}
                                    sx={{
                                        ...sx,
                                        color: fieldState.error && !field.value
                                            ? theme.palette.error.main
                                            : '',
                                        '&.Mui-checked': {
                                            color: fieldState.error && !field.value
                                                ? theme.palette.error.dark
                                                : '',
                                        },
                                        '&.Mui-disabled': {
                                            color: theme.palette.mode === "light" ? colors.grey[300] : '', // Darker color for disabled state
                                        },
                                    }}
                                />
                            }
                            label={label}
                            sx={{
                                color: fieldState.error ? theme.palette.error.main : 'inherit',
                                textDecoration: strikeThrough ? 'line-through' : 'none',
                                alignItems: 'flex-start',
                                '& .MuiTypography-root': {
                                    lineHeight: '1.5',
                                    marginTop: 1.25,
                                },
                                '& .MuiFormControlLabel-label.Mui-disabled': {
                                  color: theme.palette.mode === "light" ? colors.grey[100] : colors.grey[300], // Darker label color for disabled state
                                },
                            }}
                        />
                    </Tooltip>
                    {fieldState.error && <FormHelperText error>{fieldState.error.message}</FormHelperText>}
                </>
            )}
        />
    );
}

export default CustomCheckbox;
